<template>
  <v-container max-width="420" class="py-10">
    <div class="text-center mb-8">
      <p class="brand-kicker text-primary mb-3">Le Coq Manu</p>
      <v-icon size="56" color="primary">mdi-shield-check-outline</v-icon>
      <h1 class="text-h4 font-weight-bold mt-3">Connexion</h1>
      <p class="text-body-2 mt-2 mb-0">
        Vos courses sous surveillance
      </p>
    </div>

    <v-card>
      <v-card-text class="pa-6">
        <v-form @submit.prevent="handleLogin">
          <v-text-field
            v-model="email"
            label="E-mail"
            type="email"
            prepend-inner-icon="mdi-email-outline"
            density="compact"
            class="mb-3"
            autocomplete="email"
          />

          <v-text-field
            v-model="password"
            label="Mot de passe"
            :type="showPassword ? 'text' : 'password'"
            prepend-inner-icon="mdi-lock-outline"
            :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            density="compact"
            class="mb-4"
            autocomplete="current-password"
            @click:append-inner="showPassword = !showPassword"
          />

          <v-alert
            v-if="errorMsg"
            type="error"
            variant="tonal"
            density="compact"
            class="mb-4"
          >
            {{ errorMsg }}
          </v-alert>

          <v-btn
            type="submit"
            color="primary"
            block
            :loading="loading"
          >
            Se connecter
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <p class="text-center text-body-2 mt-4">
      Pas encore de compte ?
      <RouterLink to="/register" class="text-primary text-decoration-none font-weight-medium">
        Créer un compte
      </RouterLink>
    </p>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

export default defineComponent({
  name: 'LoginView',
  components: { RouterLink },

  setup() {
    const router       = useRouter()
    const auth         = useAuthStore()
    const email        = ref('')
    const password     = ref('')
    const loading      = ref(false)
    const errorMsg     = ref('')
    const showPassword = ref(false)

    async function handleLogin(): Promise<void> {
      errorMsg.value = ''
      loading.value  = true

      try {
        await auth.login(email.value, password.value)
        router.push({ name: 'search' })
      } catch (err) {
        errorMsg.value = err instanceof Error ? err.message : 'Une erreur est survenue.'
      } finally {
        loading.value = false
      }
    }

    return { email, password, loading, errorMsg, showPassword, handleLogin }
  },
})
</script>
